import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { TrainingCategoryList } from './TrainingCategoryList';
import { TrainingCategoryDatagrid } from './TrainingCategoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { TrainingCategory } from './TrainingCategory';

export * from './TrainingCategory';
export * from './TrainingCategoryCreate';
export * from './TrainingCategoryDatagrid';
export * from './TrainingCategoryEdit';
export * from './TrainingCategoryList';
export * from './TrainingCategoryShow';

const TrainingCategoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'name', header: 'Name' },
	// { key: 'description', header: 'Description' },
	{ key: 'imageUrl', header: 'Image URL' },
	{ key: 'organization.name', header: 'Organization Name' }
];

export const TrainingCategoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: TrainingCategory) => entity;

	const trainingCategoriesFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות אימונים', exportFields, exportDataMapper)}
				{...props}
				filters={trainingCategoriesFilter}
				bulkActionButtons={<TrainingCategoriesBulkActionButtons/>}
				title="TRAINING_CATEGORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <TrainingCategoryList/> : <TrainingCategoryDatagrid/>}
			</List>
		</Fragment>
	);
};
